import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-the-template-j" }
const _hoisted_2 = { class: "p-the-template-j__inner" }
const _hoisted_3 = { class: "p-the-template-j__header" }
const _hoisted_4 = { class: "p-the-template-j__body" }
const _hoisted_5 = { class: "p-the-template-j__body__header" }
const _hoisted_6 = { class: "p-search-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheBreadcrumb = _resolveComponent("TheBreadcrumb")!
  const _component_CommonHeading = _resolveComponent("CommonHeading")!
  const _component_FormSearch = _resolveComponent("FormSearch")!
  const _component_ValidationErrorText = _resolveComponent("ValidationErrorText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TheBreadcrumb),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          (_ctx.heading)
            ? (_openBlock(), _createBlock(_component_CommonHeading, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.heading), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "beforeSearch", {}, undefined, true),
          _createElementVNode("div", {
            ref: "searchFormElement",
            class: _normalizeClass(["p-the-template-j__search", _ctx.executeSearchFormDomAnimation ? _ctx.searchFormClassName : '']),
            style: _normalizeStyle(_ctx.executeSearchFormDomAnimation ? _ctx.serchFormStyle : {})
          }, [
            _createVNode(_component_FormSearch, {
              class: _normalizeClass(["p-the-template-j__form-search", {
                'c-search-input--empty': !_ctx.searchKeyword.trim()
              }]),
              search: _ctx.search,
              "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              placeholder: _ctx.searchPlaceholder,
              "button-color": _ctx.searchButtonColor,
              onDoSearch: _ctx.doSearch,
              onClick: _ctx.showSearchSuggest
            }, null, 8, ["search", "placeholder", "button-color", "class", "onDoSearch", "onClick"]),
            _createElementVNode("div", {
              class: "p-search-help-wrapper",
              onMouseenter: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showTooltipPc && _ctx.showTooltipPc(...args))),
              onMouseleave: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hideTooltipPc && _ctx.hideTooltipPc(...args)))
            }, [
              _createElementVNode("div", {
                class: "p-search-help",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleTooltip && _ctx.toggleTooltip(...args)), ["stop"]))
              }, " ⓘ "),
              (_ctx.showTooltip && !_ctx.isSp)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "p-search-help__tooltip",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                  }, " グループ名またはグループコード、氏名、IDで検索できます。 "))
                : _createCommentVNode("", true)
            ], 32),
            (_ctx.showTooltip && _ctx.isSp)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "p-help-modal-overlay",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showTooltip = false))
                }, [
                  _createElementVNode("div", {
                    class: "p-help-modal",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                  }, _cache[7] || (_cache[7] = [
                    _createElementVNode("div", { class: "p-help-modal__body" }, " グループ名またはグループコード、氏名、IDで検索できます。 ", -1)
                  ]))
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "searchSuggest", {}, undefined, true)
          ], 6)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createVNode(_component_ValidationErrorText, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.errorMessage]
          ])
        ]),
        _createElementVNode("div", {
          ref: "contentElement",
          class: "p-the-template-j__body__content",
          style: _normalizeStyle(_ctx.contentElementStyle)
        }, [
          _renderSlot(_ctx.$slots, "contents", {}, undefined, true)
        ], 4)
      ])
    ])
  ]))
}